
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import dailyOperationsTable from '@/components/FormComponents/dailyOperationsTable.vue'

@Component({
    components: {
        dailyOperationsTable
    }
})
export default class DailyReports extends Vue {
    private dailyOperationsTable: boolean = false;
    dailyOperations = [];

    fields: any[] = [
        {key: 'name', label: 'Name'},
        {key: 'start', label: 'Start Date'}, 
        {key: 'end', label: 'End Date'}, 
        {key: 'description', label: 'Description'},
        {key: 'button', label: 'Daily Operations'},
    ]


    get milestones () {
        return this.$store.getters['MilestoneModule/getMilestonesForActivity']
    }
    get milestoneOptions () {
        return this.milestones.map((milestone: any) => {
            return {
                text: milestone.name,
                value: milestone
            }
        })
    }

    viewDailyOperations(data:any) {
        this.dailyOperations = data.dailyOperations
        this.dailyOperationsTable = true
    }

    mounted () {
        if (this.milestones.length === 0) {
            this.$store.dispatch("MilestoneModule/getMilestonesForActivity")
        }
    }
}
